import { render, staticRenderFns } from "./LayListBooks.vue?vue&type=template&id=79367ed6&scoped=true&"
import script from "./LayListBooks.vue?vue&type=script&lang=js&"
export * from "./LayListBooks.vue?vue&type=script&lang=js&"
import style0 from "./LayListBooks.vue?vue&type=style&index=0&id=79367ed6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79367ed6",
  null
  
)

export default component.exports